import { Icon } from '@iconify/react';
import { ReactNode } from 'react';
import './PageBanner.css';

interface Crumb {
  label: string;
  href?: string;
}

interface Props {
  titulo: string;
  children?: ReactNode;
  crumbs?: Crumb[];
}

export default function PageBanner({ titulo, crumbs, children }: Props) {
  return (
    <section className="page-banner relative overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-4 py-16 md:py-20 text-center">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white">{titulo}</h1>
        {crumbs && crumbs.length > 0 && (
          <nav className="text-sm text-white/80 flex items-center justify-center gap-2 mb-3 lg:text-1.7xl">
            {crumbs.map((crumb, i) => (
              <span key={i} className="flex items-center gap-2">
                {i > 0 && <span className="text-white/60">/</span>}
                {crumb.href ? (
                  <a href={crumb.href} className="hover:text-white font-bold flex items-center gap-2"><Icon icon="mdi:home" /> {crumb.label}</a>
                ) : (
                  <span className="text-white/60">{crumb.label}</span>
                )}
              </span>
            ))}
          </nav>
        )}
        
        {children && <div className="mt-6">{children}</div>}
      </div>
    </section>
  );
}
